import React, { useMemo } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PDFViewer } from "@react-pdf/renderer";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../../../theme"; 
import InvoicePDF from "../../../../billing/bookings/InvoicePDF"; // Ensure this path matches your file structure
import { normalizePdfData } from "../utils";

const FinalBillPreviewModal = ({
  open,
  onClose,
  loading,
  error,
  invoiceData, // Raw API JSON
  hotelProfile,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Transform Data: API -> PDF Format
  const pdfData = useMemo(() => {
    return normalizePdfData(invoiceData, hotelProfile);
  }, [invoiceData, hotelProfile]);

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={open}
      onClose={onClose}
      keepMounted={false}
    >
      <DialogActions sx={{ justifyContent: "space-between", p: "12px 24px", bgcolor: colors.primary[500] }}>
        <Box>
            <Typography variant="h6" color={colors.grey[100]}>
            Final Bill Preview
            </Typography>
            <Typography variant="caption" color={colors.greenAccent[500]}>
                READ-ONLY MODE
            </Typography>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogActions>

      <DialogContent sx={{ p: 0, height: "85vh", display: "flex", flexDirection: "column", bgcolor: "#525659" }}>
        
        {/* 1. Loading State */}
        {loading && (
          <Box sx={{ display: "flex", flexDirection:"column", justifyContent: "center", alignItems: "center", height: "100%", color: 'white' }}>
            <CircularProgress color="inherit" />
            <Typography sx={{ mt: 2 }}>Fetching Latest Invoice Data...</Typography>
          </Box>
        )}

        {/* 2. Error State */}
        {error && !loading && (
          <Box sx={{ p: 3 }}>
            <Alert severity="error" onClose={onClose}>{error}</Alert>
          </Box>
        )}

        {/* 3. Success State: PDF Viewer */}
        {!loading && !error && pdfData && (
          <PDFViewer width="100%" height="100%" style={{ border: "none" }}>
            <InvoicePDF data={pdfData} />
          </PDFViewer>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FinalBillPreviewModal;